import { map } from 'lodash/fp';
import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { getScannerScopes } from '../selectors';
import IdentityDocumentScannerDialog from './IdentityDocumentScannerDialog';

// @ts-expect-error $TSFixMeError: Type 'unknown' is not assignable to type 'Key | null | undefined'.
const mapDialogs = map((scope) => <IdentityDocumentScannerDialog key={scope} scope={scope} />);

class IdentityDocumentScannerDialogsHolder extends Component {
    render() {
        return <Fragment>{mapDialogs((this.props as $TSFixMe).scopes)}</Fragment>;
    }
}

export default connect((state) => ({
    scopes: getScannerScopes(state),
}))(IdentityDocumentScannerDialogsHolder);
